/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkstepsettings3Inputs */

const en_profilelinkstepsettings3 = /** @type {(inputs: Profilelinkstepsettings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Settings.`)
};

const de_profilelinkstepsettings3 = /** @type {(inputs: Profilelinkstepsettings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geh zu Einstellungen.`)
};

/**
* | output |
* | --- |
* | "Go to Settings." |
*
* @param {Profilelinkstepsettings3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkstepsettings3 = /** @type {((inputs?: Profilelinkstepsettings3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkstepsettings3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkstepsettings3(inputs)
	return de_profilelinkstepsettings3(inputs)
});
export { profilelinkstepsettings3 as "profileLinkStepSettings" }